import { FC } from 'react';
import { Box } from '@altermaind/web/ui';
import { AccountStatus } from '@/swagger/constants/anagraphics-enums';
import { Employer } from '../../../state/types';
import { CreditsUserDashboard } from './CreditsUserDashboard';
import { EmptyState } from './EmptyState';

type Props = {
  employer: Employer;
};

export const TabCredits: FC<Props> = ({ employer }) => {
  return (
    <Box>
      {employer.status === AccountStatus.NOT_INVITED ||
      employer.status === AccountStatus.PENDING ? (
        <EmptyState employer={employer} />
      ) : (
        <CreditsUserDashboard employer={employer} />
      )}
    </Box>
  );
};
